var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaiwan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e93323",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#020090",
    d: "M0 0h15v12H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.66 4.86-1.95-.52 1.43 1.43q.16-.52.52-.91m1.84-.82q.27 0 .52.06L7.5 2.15 6.98 4.1q.25-.06.52-.06m-.76.12L5.31 2.73l.53 1.96q.38-.36.9-.53m2.42.53.53-1.96-1.43 1.43q.52.17.9.53m.7 1.07 1.43-1.42-1.95.52q.35.39.52.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5 4.33a2.19 2.19 0 1 0 0 4.38 2.19 2.19 0 0 0 0-4.38m4.38 2.2L9.91 6q.12.52 0 1.05zM8.25 8.87l1.43 1.43-.52-1.95a3 3 0 0 1-.91.52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.34 8.19 1.95.52-1.43-1.43q-.16.52-.52.9M7.5 9a3 3 0 0 1-.52-.05l.52 1.95.52-1.95A3 3 0 0 1 7.5 9m-1.66-.64L5.3 10.3l1.43-1.43a3 3 0 0 1-.9-.52m-.7-1.08L3.71 8.71l1.95-.52a3 3 0 0 1-.52-.9m-.12-.76q0-.27.06-.52l-1.95.52 1.95.53a3 3 0 0 1-.06-.53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiwan);
export default __webpack_public_path__ + "static/media/taiwan.e6bce0a54d7adec82fc3a21975172871.svg";
export { ForwardRef as ReactComponent };